// extracted by mini-css-extract-plugin
export default {"Image":"Image_Image__KgX69","Loaded":"Image_Loaded__mfCNr","rotate":"Image_rotate__0pHbg"};